<template>
  <header
    id="navbar"
    class="light fixed top-0 inset-x-0 flex items-center z-40 w-full lg:bg-transparent bg-white transition-all py-5"
  >
    <div class="container">
      <nav class="flex items-center">
        <!-- Navbar Brand Logo -->
        <router-link to="/">
          <img
            :src="settingsStore.siteLogo"
            class="h-10 logo-dark"
            alt="Logo Dark"
          />
          <img
            :src="settingsStore.siteLogo"
            class="h-10 logo-light"
            alt="Logo Light"
          />
        </router-link>

        <!-- Navigation Menu -->
        <div class="hidden lg:block ms-auto">
          <ul class="navbar-nav flex gap-x-3 items-center justify-center">
            <!-- Home Page Link -->
            <li
              class="nav-item relative"
              v-for="(menu, index) in menuStore.navbarMenu"
              :key="index"
              @click="toggleDropdown(index)"
            >
              <router-link
                class="nav-link"
                :to="menu.Link"
                v-if="!menu.IsMegaMenu"
              >
                {{ menu.Name }}
              </router-link>
              <div v-else>
                <a href="javascript:void(0);" class="nav-link">
                  {{ menu.Name }}
                  <i class="fa-solid fa-angle-down ms-2 align-middle"></i>
                </a>

                <!-- Mega Menu Dropdown -->
                <div
                  v-if="isDropdownOpen === index"
                  class="absolute top-full left-0 mt-4 bg-white rounded-lg shadow-lg border p-2 w-96 grid grid-cols-2 gap-1.5 transition-opacity duration-300 opacity-0"
                  :class="{ 'opacity-100': isDropdownOpen === index }"
                  style="z-index: 100"
                  @click.stop
                >
                  <div
                    class="nav-item"
                    v-for="(subMenu, subIndex) in menu.SubMenus"
                    :key="subIndex"
                  >
                    <router-link
                      class="nav-link flex items-center -ms-1.5"
                      :to="subMenu.Link"
                    >
                      <span
                        class="bg-blue-600/10 flex justify-center items-center w-8 h-8 shadow rounded me-3"
                      >
                        <i
                          :class="subMenu.Icon"
                          class="fa text-blue-600 w-5 h-5 text-center mt-1"
                        ></i>
                      </span>
                      <div class="flex-grow-1">{{ subMenu.Name }}</div>
                    </router-link>
                  </div>
                </div>
              </div>
            </li>
            <li class="nav-item relative">
              <router-link class="nav-link" to="/contact-us">
                İletişim
              </router-link>
            </li>
          </ul>
        </div>

        <div class="hidden lg:flex items-center ms-3">
          <router-link
            :to="{ name: 'signin' }"
            class="bg-primary text-white px-4 py-2 rounded inline-flex items-center text-sm"
            >Üye Paneli</router-link
          >
        </div>

        <div class="lg:hidden flex items-center ms-auto px-2.5">
          <button
            type="button"
            data-fc-target="mobileMenu"
            data-fc-type="offcanvas"
          >
            <i class="fa-solid fa-bars text-2xl text-gray-500"></i>
          </button>
        </div>
      </nav>
    </div>
  </header>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import { useMenuStore } from "@/stores/menuStore";
import { useSettingsStore } from "@/stores/settingStore";

const menuStore = useMenuStore();
const settingsStore = useSettingsStore();

const isDropdownOpen = ref(null);

function toggleDropdown(index) {
  if (isDropdownOpen.value === index) {
    isDropdownOpen.value = null;
  } else {
    isDropdownOpen.value = index;
  }
}

function handleClickOutside(event) {
  if (!event.target.closest("#navbar")) {
    isDropdownOpen.value = null;
  }
}

onMounted(() => {
  document.addEventListener("click", handleClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener("click", handleClickOutside);
});
</script>

<style scoped>
.nav-item .nav-link {
  position: relative;
}

.nav-item .nav-link::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -5px;
  width: 100%;
  height: 2px;
  background-color: transparent;
  transition: background-color 0.3s ease;
}

.nav-item:hover .nav-link::after {
  background-color: #007bff;
}

.grid-cols-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
</style>
